import { EMPTY_OBJECT } from '../../../../constants/common'

export function toTableAsyncFlatListCellValue({
  flat_id: id,
  flat_number: number,
  flats_count: count,
} = EMPTY_OBJECT) {
  return {
    count,
    id,
    key: number,
    name: number,
  }
}

export function getDocFlowRecipientId(item) {
  return item.recipient?.id
}
